import script from "./ApplicationStatus.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApplicationStatus.vue?vue&type=script&setup=true&lang=ts"

import "./ApplicationStatus.vue?vue&type=style&index=0&id=e4f1c514&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4f1c514"]])

export default __exports__